/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  LOAD_DRIVERS_BALANCE_REQUEST,
  LOAD_FLEET_BALANCE_REQUEST,
} from "../actions/balanceActions";

const initialState = {
  drivers: {},
  balance: 0,
};

const balanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DRIVERS_BALANCE_REQUEST: {
      const { drivers } = action.payload;
      return produce(state, (draft) => {
        draft.drivers = drivers;
      });
    }
    case LOAD_FLEET_BALANCE_REQUEST: {
      const { balance } = action.payload;
      return produce(state, (draft) => {
        draft.balance = balance;
      });
    }

    default: {
      return state;
    }
  }
};

export default balanceReducer;
